import { useEffect, useLayoutEffect, useRef } from 'react';

// Initial reads stay with their response listeners. Retry only reads/subscriptions here,
// never writes: a disconnect does not tell us whether the server applied a mutation.
export default function useSocketReconnect(socket, refresh) {
    const refreshRef = useRef(refresh);
    useLayoutEffect(() => { refreshRef.current = refresh; });
    useEffect(() => {
        if (!socket) return;
        const onConnect = () => refreshRef.current();
        socket.on('connect', onConnect);
        return () => socket.off('connect', onConnect);
    }, [socket]);
}
